import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, CircularProgress } from '@mui/material';
import { toast } from 'react-toastify';
import { AppDispatch } from '../../store';
import { useDispatch } from 'react-redux';
import { requestDownloadSupplyDocumentsAction } from '../../services/outboundService';

interface DownloadSupplyDocumentsDialogProps {
  open: boolean;
  onClose: () => void;
  onDownloaded: () => void;
}

export const DownloadSupplyDocumentsDialog: React.FC<DownloadSupplyDocumentsDialogProps> = ({ open, onClose, onDownloaded }) => {
  const dispatch = useDispatch<AppDispatch>();
  const maxCountDocuments = process.env.REACT_APP_MAX_COUNT_DOCUMENTS ? Number(process.env.REACT_APP_MAX_COUNT_DOCUMENTS) : 100;

  const [supplyNumbers, setSupplyNumbers] = useState<string>('');
  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState<Record<string, string>>({});

  useEffect(() => {
    if (open) {
      setSupplyNumbers('');
      setErrors({});
    }
  }, [open]);

  useEffect(() => {
    if (!open) {
      return;
    }
  }, [open, dispatch]);

  const validate = () => {
    const newErrors: Record<string, string> = {};
    if (!supplyNumbers) {
      newErrors.supplyNumbers = 'Укажите номера рейсов';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleDownload = (url: string) => {
    const fullUrl = `${process.env.REACT_APP_API_BASE_URL}${url}`;
    const fileName = url.split('/').pop() || 'acts.zip';

    const link = document.createElement('a');
    link.href = fullUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    setSubmitting(true);
    setErrors({});

    try {
      const cleanedInput = supplyNumbers.trim().replace(/ /g, '');
      const supplyIds = cleanedInput.split('\n').filter(Boolean);

      if (supplyIds.length > maxCountDocuments) {
        setErrors({ supplyNumbers: 'Превышено количество рейсов!' });
        return;
      }

      const invalidId = supplyIds.find((id) => isNaN(Number(id)));
      if (invalidId) {
        setErrors({ inboundNumbers: 'Проверьте правильность номеров рейсов!' });
        return;
      }

      const payload = supplyIds.map((id) => ({ id: Number(id) }));

      const response = await requestDownloadSupplyDocumentsAction(payload);
      if (response?.url) {
        handleDownload(response.url);
        toast.success('Файлы успешно загружены!');
        onDownloaded();
        onClose();
      } else {
        toast.error('Не удалось получить ссылку на файл.');
      }
    } catch (err: any) {
      toast.error(err?.error || 'Ошибка при скачивании!');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Скачать акты</DialogTitle>
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          mt: 1,
          paddingTop: '10px !important',
        }}
      >
        <p>
          Укажите номера Supply. Каждый номер с новой строки.
          <br />
          Не более {maxCountDocuments} Supply.
        </p>
        <TextField
          id="outlined-multiline-static"
          label="Номера Supply"
          multiline
          rows={5}
          value={supplyNumbers}
          onChange={(e) => setSupplyNumbers(e.target.value)}
          error={!!errors.supplyNumbers}
          helperText={errors.supplyNumbers}
        />
      </DialogContent>
      <DialogActions sx={{ padding: '20px 24px' }}>
        <Button onClick={onClose} color="inherit" disabled={submitting}>
          Отмена
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="success" disabled={submitting}>
          {submitting ? <CircularProgress size={20} /> : 'Скачать'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
